const pt = {
  'Language Key': 'pt',
  'cui-org-info': 'informações organização',
  'cui-sign-on-info': 'Assinar em informações',
  'cui-user-info': 'Informação de usuário',
  'cui-preferences': 'preferências',
  'cui-review': 'Reveja',
  'cui-org': 'Organização',
  'cui-company-division': 'Divisão de empresa',
  'cui-org-address': 'organização Endereço',
  'cui-user-address': 'Endereço usuário',
  'cui-country': 'País',
  'cui-city': 'Cidade',
  'cui-state': 'Estado / Província',
  'cui-postal': 'Código postal',
  'cui-user-id': 'ID do usuário',
  'cui-password': 'Senha',
  'cui-password-re': 'Digite novamente a senha',
  'cui-challenge-question': 'Questão Desafio',
  'cui-challenge-answer': 'resposta desafio',
  'cui-favorite-pet-q': 'Qual o nome do seu animal de estimação favorito?',
  'cui-mother-q': 'Qual é o nome de solteira da sua mãe?',
  'cui-best-friend-q': 'Quem é seu melhor amigo?',
  'cui-first-name': 'Primeiro nome',
  'cui-last-name': 'Último nome',
  'cui-email': 'O email',
  'cui-email-re': 'Re-enter email',
  'cui-telephone': 'Número de telefone',
  'cui-timezone': 'Fuso horário',
  'cui-submit': 'ENVIAR',
  'cui-next': 'PRÓXIMO PASSO',
  'cui-previous': 'ANTERIOR',
  'cui-create-security-admin-account': 'Crie a sua conta de administrador de segurança',
  'cui-skip-for-now': 'Ignorar por enquanto',
  'icon-library': 'icon Library',
  'cui-new-TLO': 'Nova Organização Nível Superior',
  'cui-new-TLO-description': 'Escolha este método se você deseja participar do Intercâmbio Covisint como uma nova Organização Covisint',
  'cui-new-division': 'nova Divisão',
  'cui-new-division-description-start': 'Escolha este método se você gostaria de se tornar o',
  'cui-new-division-description-end': 'de uma nova divisão dentro de uma organização Covisint existente.',
  'cui-security-administrator': 'Administrador de segurança',
  'cui-new-user': 'Novo usuário',
  'cui-new-user-description': 'Escolha este método se você é um empregado de uma existente Covisint Membro Empresa que procura acesso a um aplicativo sua organização subscreve ou se você não tem certeza se a sua organização está registrado.',
  'cui-sign-up': 'Inscrever-se',
  'cui-address': 'Endereço',
  'cui-organization-name': 'Divisão de empresa',
  'cui-supplier-code': 'Código de fornecedor',
  'cui-address-1': 'Endereço 1',
  'cui-address-2': 'Endereço 2',
  'cui-user-information': 'Informação do usuário',
  'cui-organization-information': 'Informações da organização',
  'cui-sign-in-information': 'Entrar Informações',
  'cui-package-selection': 'Seleção de Pacotes',
  'cui-welcome-popover': 'As responsabilidades do administrador de segurança será explicado em detalhes depois de selecionar um método de registo. No entanto, você pode optar por cancelar o seu registo, a fim de permitir que um membro diferente do seu Organiziation registar-se como o administrador de segurança.',
  'create-account': 'Crie sua conta',
  'cui-agree-covisint': 'Concordo com a Covisint',
  'terms-of-service': 'Termos de serviço',
  'cui-and': 'e',
  'privacy-policy': 'Política de Privacidade',
  'cui-tos-agree': 'Você deve concordar com os Termos de Serviço para continuar.',
  'cui-user-profile': 'Perfil de usuário',
  'cui-my-profile': 'Meu perfil',
  'cui-login': 'Entrar',
  'cui-supplier-content': 'Atualizar esta uma vez que os documentos de design vêm em. Este é na Tradução de Google doc. Lorem Ipsum. Outras coisas. código de fornecedor informações importantes. Eu gosto de tartarugas.',
  'cui-all-organizations': 'Todas as Organizações:',
  'cui-application-select-info': 'Você sempre pode fazer suas seleções após o login pela primeira vez.',
  'cui-all-applications': 'todas as aplicações',
  'cui-page-not-found': 'Página não encontrada',
  'cui-page-not-found-content': 'A página que você está procurando pode ter sido excluído ou nunca existiram.',
  'cui-home': 'CASA',
  'cui-access-denied': 'Acesso negado',
  'cui-access-denied-content': 'Você não está autorizado a visualizar esta página.',
  'cui-registration-status': 'Status de registro',
  'cui-pending-status': 'pendente Estado',
  'cui-pending-status-content': 'Seu status de registro ainda está pendente. Você receberá um e-mail com mais detalhes em breve.',
  'cui-thank-you': 'Obrigado',
  'cui-request-submitted': 'Solicitação Enviada',
  'cui-success': 'Sucesso',
  'cui-success-content': 'O seu registo Covisint foi enviada com sucesso. Você receberá um e-mail com mais detalhes em breve.',
  'cui-check-your': 'Verifique se o seu',
  'cui-registration-status-lower': 'Status de registro',
  'cui-application-selection': 'Seleção de aplicação',
  'cui-applications': 'aplicações',
  'cui-profile-settings': 'Configurações de perfil',
  'cui-name': 'Nome',
  'cui-update': 'Atualizar',
  'cui-updated': 'Atualizada',
  'cui-error-try-again': 'Erro! Tente novamente?',
  'cui-back': 'Costas',
  'cui-selections': 'seleções',
  'cui-add-org': 'Adicionar Organização',
  'cui-remove-org': 'Remover Organização',
  'cui-select-org': 'Selecione Organização',
  'cui-more-information': 'Mais Informações',
  'cui-inv-user-popover-info': 'Por razões de segurança, você deve se registrar com o e-mail seu convite foi enviado. Isso pode ser editado dentro de configurações do usuário quando o registro for concluído.',
  'cui-org-profile': 'Perfil organização',
  'cui-info': 'informações',
  'cui-admins': 'Administradores',
  'lowercase-not-allowed': 'não tem nenhum letras minúsculas',
  'uppercase-not-allowed': 'não tem nenhum letras maiúsculas',
  'numbers-not-allowed': 'não tem nenhum números',
  'special-not-allowed': 'não tem nenhum símbolos especiais (ex: * +)',
  'chars-not-allowed': 'não contém nenhum dos seguintes caracteres: {{disallowedChars}}',
  'words-not-allowed': 'não conter nenhuma das palavras seguintes: {{disallowedWords}}',
  'password-length': 'ter entre {{min}}-{{max}} caracteres',
  'password-rules': 'ter {{requiredNumberOfCharClasses}} dos seguintes:',
  'password-lowercase': 'pelo menos uma letra minúscula',
  'password-uppercase': 'pelo menos uma letra maiúscula',
  'password-number': 'pelo menos um número',
  'password-special': 'pelo menos 1 símbolo especial (ex: * +)',
  'passwords-must': 'As senhas devem:',
  'welcome-title': 'Se inscrever para um dos seguintes',
  'cui-application-name': 'Nome da Aplicação',
  'cui-application-tos': 'Rever os Termos e Condições',
  'cui-application-tos-agreement': 'Termos e Condições Acordo',
  'cui-package-tos': 'Você não aceitou os termos para os pacotes selecionados.',
  'cui-view-tos': 'Ver Termos e Condições',
  'password-mismatch': 'As senhas devem corresponder',
  'cui-back-to-review': 'Voltar ao Comente',
  'email-mismatch': 'Os e-mails devem corresponder',
  'no-applications-selected': 'Você não tem nenhum aplicações seleccionadas. Clique aqui para voltar à seleção aplicação.',
  'cui-all-fields-required': 'Todos os campos são necessários',
  'cui-complete-registration': 'Completar seu cadastro abaixo com',
  'cui-registered': 'Registrado',
  'cui-open': 'Aberto',
  'cui-close': 'Fechar',
  'cui-street-address': 'Endereço',
  'cui-zip': 'Fecho eclair',
  'cui-language': 'Língua',
  'cui-phone-main': 'a Principal',
  'cui-phone-office': 'Escritório',
  'cui-phone-fax': 'Telefone / Fax',
  'cui-phone-mobile': 'Móvel',
  'cui-save': 'Salve ',
  'cui-cancel': 'Cancelar',
  'cui-edit': 'Editar',
  'cui-phone': 'telefone',
  'search-by-app-name': 'Busca por nome do aplicativo',
  'new-request': 'Novo pedido',
  'select-applications': 'Seleccione Aplicações',
  'browse-applications': 'Procurar Aplicações',
  'go': 'Ir',
  'filter-list': 'Lista de filtros',
  'filter': 'Filtro',
  'owning-org': 'possuir Org',
  'my-applications': 'As minhas aplicações',
  'app-summary': 'app Resumo',
  'granted': 'concedido',
  'bundled-applications': 'Aplicativos Incluídos',
  'application-details': 'Detalhes da aplicação',
  'my-claims': 'minhas reivindicações',
  'related-applications': 'Aplicações relacionadas',
  'review-request': 'Pedido de revisão',
  'back-to-search': 'Voltar à procura',
  'requested-items': 'Itens solicitados',
  'request-reason': 'pedido Razão',
  'reason-im-requesting': 'Razão pela qual estou solicitando',
  'you-must-enter-a-reason': 'Você deve inserir um motivo para solicitar este aplicativo',
  'cui-org-no-applications': 'Parece que a sua organização não tem nenhum aplicações. Você sempre pode tentar novamente após o login.',
  'cui-filter-org-name': 'Filtrar por nome da organização',
  'cui-address-example': 'Apt, Suite, Bldg. (opcional)',
  'cui-filter-app-name': 'Filtrar por nome do aplicativo',
  'cui-search-user-name': 'Pesquisar usuários por nome',
  'page': 'Página',
  'cui-num-results-page': 'Resultados por página',
  'submit-request': 'Enviar pedido',
  'categories': 'categorias',
  'cui-answer': 'Responda',
  'cui-enter-password': 'Digite a senha',
  'cui-enter-new-password': 'Insira a nova senha',
  'cui-re-enter-new-password': 'Re-introduza a nova palavra-passe',
  'granted-to-my-org': 'Concedido a minha organização',
  'collected-items-for-request': 'Os envios recolhidos para Request',
  'cui-invalid-password': 'Senha inválida. Por favor, tente novamente.',
  'cui-faq': 'Perguntas frequentes',
  'cui-frequently-asked-questions': 'perguntas frequentes',
  'cui-admin-tools': 'Ferramentas de Administração',
  'cui-this-field-is-required': 'Este campo é obrigatório.',
  'cui-this-field-needs-to-be-longer': 'Este campo precisa ser mais longo.',
  'cui-you-need-to-agree-to-toc': 'Você precisa concordar com os Termos de Serviço antes de continuar.',
  'cui-this-is-not-valid-email': 'Este não é um email válido.',
  'cui-my-app-requests': 'Meus Pedidos de Aplicação',
  'cui-no-claims': 'Você não tem reivindicações para esta aplicação.',
  'cui-no-details': 'Não há detalhes disponíveis.',
  'request': 'Pedido',
  'all': 'Todos',
  'no-selected-apps': 'Você não selecionou nenhum aplicações.',
  'basic-info': 'Informação básica',
  'cui-error-username-exists': 'ID de usuário já existe! Por favor escolha outro.',
  'password-reset': 'Resetar a senha',
  'current-password': 'senha atual',
  'timezone-and-language': 'Fuso horário e idioma',
  'challenge-questions': 'Perguntas de desafio',
  'security-question-repeated': 'Esta resposta já foi usado.',
  'cui-by-date-added': 'data adicionada',
  'cui-alphabetically': 'alfabética',
  'active': 'Ativo',
  'pending': 'Pendente',
  'suspended': 'suspenso',
  'title': 'Título',
  'id': 'identidade',
  'url': 'Url',
  'privacy-terms': 'Privacidade e Termos',
  'help': 'Socorro',
  'cui-learn-more-start': 'Saber mais',
  'cui-learn-more-end': 'sobre por que pedimos por esta informação',
  'cui-org-hierarchy': 'organização Hierarquia',
  'directory': 'Diretório',
  'userID': 'ID do usuário',
  'status': 'estado',
  'locked': 'trancado',
  'rejected': 'rejeitado',
  'removed': 'Removido',
  'sort': 'Ordenar',
  'refine': 'Refinar',
  'or': 'Ou',
  'organizations': 'organizações',
  'roles': 'Roles',
  'organization-applications': 'Aplicações organização',
  'unactivated': 'unactivated',
  'log-out': 'Sair',
  'welcome': 'Bem vinda',
  'privacy': 'Privacidade',
  'terms': 'condições',
  'user': 'Do utilizador',
  'top-level-orgs': 'Principais organizações de nível',
  'invite-user': 'Convidar Usuário',
  'invite-division': 'Convidar Divisão',
  'username': 'Nome de Usuário',
  'move': 'mover',
  'no-bundled-or-related': 'Sem empacotados ou aplicativos relacionados.',
  'cui-continue': 'Continuar',
  'cui-no-org-divisions': 'Não há divisões organização',
  'inactive': 'Inativo',
  'deny': 'Negar',
  'approve': 'Aprovar',
  'pending-request': 'Pedido pendente',
  'review-approvals': 'revisão Aprovações',
  'cui-package-no-claims': 'Este pacote não contém reivindicações',
  'claims': 'reivindicações',
  'package-name': 'Nome do pacote',
  'submit-approvals': 'submeter Aprovações',
  'view-details': 'Ver detalhes',
  'request-date': 'Data do Pedido',
  'registration-decision': 'Decisão de registro',
  'requested': 'Requeridos',
  'getting-user-info': 'Recebendo suas informações de usuário ...',
  'approvals-submitted': 'aprovações Submetido',
  'rejection-submitted': 'rejeição Submetido',
  'approval-summary': 'Resumo aprovação',
  'approved-items': 'Itens aprovados',
  'rejected-items': 'Os itens rejeitados',
  'registration-request-approved': 'pedido de registro aprovado',
  'registration-request-rejected': 'pedido de registro rejeitado',
  'no-items-rejected': 'Nenhum item rejeitado',
  'no-items-approved': 'Nenhum item aprovado',
  'registration-request': 'Pedido de registro',
  'custom-api-loading': 'A inicialização do aplicativo ...',
  'new-grant': 'Grant App',
  'search-by-package-name': 'Pesquisa por nome de pacote',
  'search': 'Pesquisa',
  'administartor-?': 'Administrador?',
  'submit-grant-update': 'Enviar atualização concessão',
  'review-user-pending-approval': 'Revisão Usuário Aprovação Pendente',
  'view-request-for': 'Ver Pedido de',
  'job-title': 'Titulo do trabalho',
  'query': 'Inquerir',
  'suspend-app': 'suspender App',
  'new-grants': 'novas bolsas',
  'update-grant-settings': 'Configurações Grant atualização',
  'assign-new-grant-to': 'Atribuir nova concessão para',
  'division': 'Divisão',
  'redirecting-to-sso': 'Solicitando suas credenciais',
  'included-applications': 'Aplicações incluídas',
  'selected-sub-packages': 'Sub-pacotes selecionados',
  'specify-password': 'especificar senha',
  'suspend': 'Suspender',
  'reset-password': 'Password Reset',
  'confirm-password-reset': 'Tem certeza de que deseja redefinir a senha para este usuário?',
  'yes': 'sim',
  'within': 'dentro',
  'search-within': 'Pesquisar dentro',
  'in-your-org': 'em sua org',
  'people': 'Pessoas',
  'revoke-package': 'revogar Package',
  'cui-by-username': 'Nome de Usuário',
  'cui-by-status': 'estado',
  'cool-got-it': 'Legal, entendeu',
  'organization-directory': 'Diretório da organização',
  'org-nav-invite-links': 'Organização de navegação e links Convite',
  'org-dir-filters': 'Filtros Diretório Organização',
  'org-dir-list': 'Lista Diretório Organização',
  'apps': 'Apps',
  'apps-upper': 'APPS',
  'history-upper': 'HISTÓRIA',
  'profile-upper': 'PERFIL',
  'roles-upper': 'PAPÉIS',
  'your-app-request-in-review': 'Seu pedido foi entregue o pedido',
  'error-generic': 'Houve um problema ao carregar os dados nesta página. Por favor, tente novamente.',
  'cui-application-administrator': 'atualmente não têm a função de administrador da aplicação, que deve ser atribuído antes de um usuário pode ser concedido direitos de administração para uma determinada aplicação. Esta é uma definição de tempo.',
  'cui-assign-confirm': 'Você gostaria de atribuir este papel agora?',
  'cui-suspend-warning': 'não será capaz de aceder a esta aplicação',
  'cui-suspend-confirm': 'Tem certeza de que gostaria de suspender agora?',
  'cui-notify-user': 'Notificar usuário',
  'cui-users': 'Comercial',
  'cui-no': 'Não',
  'cui-remove': 'Removido',
  'cui-org-abbrev': 'Org',
  'cui-userProfile-user-error': 'Houve um erro ao recuperar os dados do usuário. Por favor, tente novamente.',
  'cui-userProfile-security-error': 'Houve um erro ao recuperar os dados pergunta de segurança. Por favor, tente novamente.',
  'cui-userProfile-password-error': 'Houve um erro ao recuperar dados de política de senha. Por favor, tente novamente.',
  'cui-suspend-success': 'Esta aplicação está suspensa a partir do utilizador seleccionado',
  'cui-unlock': 'destravar',
  'cui-unlock-password-confirm': 'Tem certeza que você gostaria de desbloquear a senha do usuário?',
  'cui-error-unlocking-password': 'Desculpe, houve um erro desbloquear a senha do usuário.',
  'cui-error-person-request': 'Não é possível recuperar dados de solicitação de inscrição para este usuário.',
  'cui-error-email-exists': 'endereço de e-mail já foi tomada',
  'cui-password-history-rule': 'não corresponde a nenhum dos seus anteriores {{numberOfPasswords}} senhas',
  'cui-password-policy': 'política de senha',
  'cui-security-admin': 'Administradores de segurança',
  'cui-button-loading-text': 'Carregando...',
  'cui-username-taken': 'Nome de Usuário indisponível',
  'cui-no-applications': 'Atualmente você não tem aplicações',
  'cui-mask-answers': 'Máscara de respostas de segurança / desmascarar',
  'cui-pwd-reset-success': 'Password Reset sucesso!',
  'cui-last-login': 'Último login',
  'cui-need-different-app': 'Precisa de uma aplicação diferente',
  'cui-go-back-to': 'Volte para',
  'cui-tos-applications': 'Por favor, aceite os Termos e Condições para os aplicativos selecionados',
  'cui-selected-apps': 'Os pedidos seleccionados',
  'cui-authentication-policy': 'política de autenticação',
  'cui-selected': 'Selecionado',
  'cui-tac': 'Termos e Condições',
  'cui-accept': 'Aceitar',
  'cui-tac-agree': 'Você deve concordar com os Termos e Condições para continuar.',
  'cui-printer-friendly-tac': 'para impressão Termos e Condições',
  'cui-my-history': 'Minha história',
  'cui-status-history': 'Meu Histórico de Status',
  'cui-app-history': 'História aplicação',
  'cui-password-change-log': 'log alteração de senha',
  'cui-date': 'Encontro',
  'cui-event-type': 'Tipo de evento',
  'cui-action-by': 'Acção efectuada por',
  'cui-notes': 'Notas',
  'cui-try-again': 'Por favor, tente novamente.',
  'cui-password-change-log-error': 'Houve um log de alterações de senha recuperação de erro.',
  'cui-userstatus-history-error': 'Havia uma história Status de usuário recuperando erro.',
  'cui-claims-error': 'Houve um erro ao recuperar Reivindicações.',
  'cui-org-app-suspend-success': 'Esta aplicação está agora suspensos das organizações selecionadas, todos os usuários, e todas as organizações sub.',
  'cui-org-app-suspend-msg1': 'Esta acção irá suspender a ação de todos os usuários e as organizações sub mesmo quando em uso ativo.',
  'cui-org-app-suspend-msg2': 'Tem certeza de que deseja suspender',
  'cui-from': 'a partir de',
  'cui-application-granted-history': 'Aplicação Histórico Grant',
  'cui-application-requested-history': 'Pedido Histórico aplicação',
  'approved': 'aprovado',
  'decision': 'Decisão',
  'evaluator': 'avaliador',
  'action': 'Açao',
  'cui-invalid-invitation': 'O convite é ou já usados ​​ou inválido',
  'cui-by-request-date': 'Data do Pedido',
  'cui-by-decision-date': 'Data de decisão',
  'cui-no-orgs-for-name': 'Nenhuma organização encontrados para o nome especificado. Por favor, tente com um nome diferente.',
  'requests': 'solicitações de',
  'no-pending-apps': 'Você não tem solicitações de aplicativos pendentes.',
  'description': 'Descrição',
  'launch': 'Lançamento',
  'manage-applications': 'Gerenciar aplicativos',
  'request-type': 'tipo de solicitação',
  'phase': 'Estágio',
  'date-submitted': 'Data Enviada',
  'cui-pending-requests-error': 'Houve um erro na recuperação / atualização de solicitações.',
  'no-requests-by-name': 'Nenhum pedido encontrados para o nome especificado. Por favor, tente com um nome diferente.',
  'cannot-change-password': 'Não é possível alterar a senha agora',
  'select-claims': 'Seleccione Claims',
  'grant-reason': 'Grant Reason',
  'grants-assigned': 'Novas concessões Assigned',
  'suspend-error': 'Houve um erro no suspender solicitações.',
  'unsuspend-error': 'Houve um erro no pedidos UNSUSPEND.',
  'approval': 'Aprovação',
  'administrator': 'Administrador',
  'submitted': 'Submetido',
  'no-bundled': 'Nenhum aplicativo empacotados',
  'disallowed-password-rule': 'não pode conter uma palavra na lista de palavras anulado',
  'request-approve-or-rejected': 'Este pedido é ou Aprovado / Rejeitado',
  'application': 'Aplicação',
  'show-all': 'Mostre tudo',
  'cui-subject': 'Sujeito',
  'cui-es': '(ES)',
  'cui-invite-user': 'Convidar um usuário dentro',
  'cui-invite-user-success': 'o seu pedido de convite de usuário enviado',
  'cui-email-recipt': 'Digite e-mail do destinatário (múltipla separado com vírgulas)',
  'cui-invite-verbiage': 'Convidar para um dos seguintes',
  'select': 'selecionar',
  'change-org': 'mudança Org',
  'cui-invite-user-sub': 'Registre-se como um usuário para se juntar',
  'cui-invite-user-select': 'Pesquise um org',
  'cui-send-invitation': 'Enviar convite',
  'invite': 'Convite',
  'cui-invite-tlo-success': 'Seu nível superior pedido organização convite enviado',
  'cui-invite-tlo': 'Convidar uma nova organização',
  'cui-invite-division-success': 'Seu pedido de convite empresa enviou',
  'cui-invite-division': 'Convidar uma organização',
  'cui-tlo-sub': 'Registre-se como uma nova organização',
  'cui-division-sub': 'Registre-se como um administrador dentro',
  'search-by-org-name': 'Busca por nome da organização',
  'app-approval-error': 'Houve um erro na aprovação de solicitações de aplicativos.',
  'modify-claims': 'modificar Claims',
  'unsuspend-app': 'UNSUSPEND App',
  'remove-app': 'Remover App',
  'user-details': 'Detalhes do usuario',
  'reason': 'Razão',
  'required': 'Requeridos',
  'cui-unsuspend-confirm': 'Tem certeza de que gostaria de reativar agora?',
  'unsuspend': 'UNSUSPEND',
  'remove-confirm': 'Tem certeza de que deseja remover agora?',
  'remove': 'Remover',
  'my-organization': 'minha Organização',
  'request-app': 'Request App',
  'no-apps-found': 'Nenhum aplicativo encontrado.',
  'refine-search': 'Por favor, refine seus critérios de busca.',
  'your-assign-role-success': 'Novo papel atribuído',
  'cui-assigned-roles': 'funções atribuídas',
  'cui-available-roles': 'Funções disponíveis',
  'cui-browse-by-category': 'Pesquise por Categoria',
  'cui-back-navigation-requests': 'navegação para trás e Solicitações',
  'cui-search-results': 'Procurar Resultados',
  'cui-new-grant-search-results': 'Resultados da Pesquisa New Grant',
  'cui-username-close': 'nome de usuário e perto de navegação',
  'cui-user-no-apps': 'Usuário não tem aplicações',
  'cui-no-roles-assigned': 'Este usuário não tem funções atribuídas.',
  'status-history': 'Histórico de Status',
  'cui-no-status-history': 'Este utilizador não tem histórico de status.',
  'cui-pwd-reset-msg1': 'Password Reset é bem sucedida. Nova senha é:',
  'cui-pwd-reset-msg2': 'Nota: se você está vendo apenas a primeira metade de senha, em seguida, a segunda metade senha será enviada para utilizadores registados e-mail.',
  'users-upper': 'COMERCIAL',
  'hierarchy-upper': 'HIERARQUIA',
  'privileges': 'privilégios',
  'expand-all': 'Expandir todos',
  'collapse-all': 'Recolher todos',
  'no-records': 'Nenhum registro foi encontrado.',
  'contact-us': 'Contate-Nos',
  'cui-error-organization-request': 'Não é possível recuperar dados de solicitação de inscrição para esta organização.',
  'cui-error-organization-app-request': 'Não é possível recuperar dados de solicitação de aplicativo para esta organização',
  'cui-error-user-app-request': 'Não é possível recuperar dados de solicitação de aplicativo para esse usuário',
  'assign': 'Atribuir',
  'search-by-person-name': 'Procura por nome pessoa',
  'grant-history': 'História Grant',
  'request-history': 'pedido Histórico',
  'social-login': 'Entrada social',
  'facebook': 'Facebook',
  'twitter': 'Twitter',
  'link': 'Ligação',
  'unlink': 'desligar',
  'invalid-url': 'Esta não é uma URL válida.',
  'linkedin': 'LinkedIn',
  'google': 'Google',
  'administration': 'Administração',
  'services': 'Serviços',
  'n-phase': 'N - Fase Aprovação',
  'edit-package': 'Editar Package',
  'is-requestable': 'é Requestable',
  'is-displayable': 'é Displayable',
  'is-grantable': 'é grantable',
  'require': 'exigir',
  'is-requestable-desc': 'Indicam se o usuário pode solicitar esta aplicação.',
  'is-grantable-desc': 'Indicar se esta aplicação pode ser concedido diretamente pela administração da empresa para o usuário',
  'is-displayable-desc': 'Indicar se o ícone do pacote deve ser exibida na página My Applications',
  'require-reason-desc': 'Indicar se este pacote necessário que o usuário forneça um motivo para solicitar este pacote',
  'company-admin': 'empresa administrador',
  'application-admin': 'aplicativo Administração',
  'company-admin-desc': 'Esta é a fase de aprovação padrão, deve ser Sim, se não houver outra fase necessário',
  'application-admin-desc': 'Será que a aplicação do usuário pedido precisa ser aprovado pelo administrador da aplicação?',
  'add-admins': 'Adicionar administradores',
  'cardinality-indicator': 'Indicador cardinality',
  'cui-one': '1',
  'cui-many': 'Muitos',
  'claim-values': 'valores de declarações',
  'cui-add': 'Adicionar',
  'cui-view': 'Visão',
  'cui-claim': 'Afirmação',
  'cui-category': 'Categoria',
  'cui-service': 'Serviço',
  'cui-delete': 'Excluir',
  'federation-conn': 'Connection Federação',
  'updated-date': 'data de atualização',
  'target-url': 'Alvo URL',
  'remote-app-id': 'Remoto Id Aplicação',
  'mobile-sso-url': 'URL SSO móvel',
  'mobile-app-id': 'Mobile App ID',
  'cui-package': 'Pacote',
  'cui-create': 'Crio',
  'more-languages': 'mais Idiomas',
  'duplicate-language-error': 'línguas duplicados não são permitidos',
  'cui-nextstep': 'Próximo',
  'create-package': 'Criar pacote',
  'manage-package-claims': 'Gerenciar Reivindicações da Embalagem',
  'cardinality-indicator-error': 'Indicador Cardinality não pode ser um',
  'value-id-exists': 'O ID do valor já existe',
  'claim-id-exists': 'Reivindicação Id já existe',
  'cui-new': 'Novo',
  'package-success-content': 'Pacote criado com sucesso',
  'add-claims': 'Adicionar Claims',
  'package-update-success': 'Pacote atualizado com sucesso'
}

export {
  pt
}



// WEBPACK FOOTER //
// ./src/plugins/i18n/pt.js